if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  // Premiom : la barre de recherche BSS n'existe que sur ses pages ; sans limite, cette
  // recherche tournait chaque seconde pendant toute la visite, sur toutes les pages.
  let searchBarTries = 0;
  let interval = setInterval(() => {
    const search_bar = document.querySelector(".bss-b2b-search-bar");
    if (!search_bar && ++searchBarTries >= 30) {
      clearInterval(interval);
      return;
    }
    if (search_bar) {
      clearInterval(interval);
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.id === "search-result") {
            (async function () {
              if (BSS_B2B) {
                const res = await BSS_B2B.storage.productStorage.load();
                if (res) {
                  if (
                    res.notExistProductIds?.length ||
                    res.productIds?.length ||
                    res.variantIds?.size
                  ) {
                    BSS_B2B.observer.productSubject.notifyObserver(
                      "LazyProduct",
                      "LoadedLazyProduct",
                      {
                        ...res,
                      }
                    );
                  }
                }
              }
            })();
          }
        }
      });
      observer.observe(search_bar, { childList: true, subtree: true });
    }
  }, 1000);

  setTimeout(() => {
    //RF
    if (window.location.pathname === "/account/register") {
      const divs = document.querySelectorAll(
        "#bss-b2b-registration-form-render div.form-group:not(.field-country-field)"
      );
      if (divs.length) {
        divs.forEach((item) => {
          const input = item.querySelector("input, select, textarea");
          const label = item.querySelector("label");
          if (input && label) {
            input.placeholder = " ";
            input.after(label);
          }
        });
      }
    }
  }, 1000);
}


const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;

if (pageType !== "cart") {
  let counter = 0;
  const interval = setInterval(() => {
    const footerPrice = document.querySelector(".footer-cart-drawer-mobile");
   
    if (footerPrice){
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
} else {
  let counter = 0;
  const interval = setInterval(() => {
    const vatInputWrapper = document.querySelector(".bss-b2b-vat-input-wrapper");

    if (vatInputWrapper) {
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}

function handleTEBox() {
  // Premiom : BSS absent (app désactivée, bloqueur) ou module TVA non chargé.
  if (typeof BSS_B2B === "undefined" || !BSS_B2B || !BSS_B2B.te) return;
  const translations = BSS_B2B.te.teTranslations || {};
  const headerText = document.querySelector(
    ".bss-b2b-translation-vat-form_header_text"
  );
  if (headerText) {
    headerText.innerText = translations.form_header_text;
  }

  const subtitleText = document.querySelector(
    ".bss-b2b-translation-vat-form_subtitle_text"
  );
  if (subtitleText) {
    subtitleText.innerText = translations.form_subtitle_text;
  }

  const successMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_success_message"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_success_message_us_ein"
    ),
  ];

  successMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_success_message || "";
          break;
        case 1:
          msg.innerText = translations.form_success_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_success_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_success_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_success_message_us_ein || "";
          break;
      }
    }
  });

  const errorMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_error_message"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_error_message_us_ein"
    ),
    document.querySelector(
      ".bss-b2b-translation-vat-form_validate_country_code_message"
    ),
  ];

  errorMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_error_message || "";
          break;
        case 1:
          msg.innerText = translations.form_error_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_error_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_error_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_error_message_us_ein || "";
          break;
        case 5:
          msg.innerText = translations.form_validate_country_code_message || "";
          break;
      }
    }
  });
}

/* Premiom : le thème remplace les boutons de checkout à chaque re-render du panier
   (innerHTML des sections). BSS ne les ré-attache qu'après un debounce de 300 ms ;
   on les ré-attache dès leur apparition. La barrière premiom-bss-checkout-guard
   bloque de toute façon un clic sur un bouton non attaché. */
const PREMIOM_BSS_UNBOUND_CHECKOUT =
  '[name="checkout"]:not([bss-b2b-cart-trigger-added]), #checkout-submit:not([bss-b2b-cart-trigger-added])';

function premiomBindBssCheckout() {
  const subject =
    typeof BSS_B2B !== "undefined" && BSS_B2B && BSS_B2B.observer && BSS_B2B.observer.cartSubject;
  if (subject && document.querySelector(PREMIOM_BSS_UNBOUND_CHECKOUT)) subject.listenCartCheckout();
}

/* Premiom : double affichage du prix pour le contenu injecté (panneau « Choisissez les
   options » des cartes, sections/choose-option.liquid). Même règle que la fiche produit
   (script inline de premiom-product-purchase) :
   - [data-premiom-price-source] (#price-<id>) est le brouillon, invisible : le thème y
     écrit le prix public de la variante, puis BSS le tarif pro, et le rend visible à la
     fin de son calcul ;
   - [data-premiom-price-display] est le seul prix affiché. Il recopie le brouillon
     visible dès que BSS l'a réécrit (plus de racine `.main-product-price`, celle de
     price.liquid) ; un prix du thème n'est recopié que s'il reste stable 1,5 s (client
     sans tarif BSS, BSS absent). Entre-temps, l'ancien prix reste : ni vide, ni prix
     public. */
function premiomBindPriceDisplay(source) {
  if (source.premiomPriceBound) return;
  const display = source.parentElement && source.parentElement.querySelector("[data-premiom-price-display]");
  if (!display) return;
  source.premiomPriceBound = true;
  let pending;
  const copy = () => {
    clearTimeout(pending);
    if (display.innerHTML !== source.innerHTML) display.innerHTML = source.innerHTML;
    display.style.visibility = "";
  };
  const sync = () => {
    display.classList.toggle("hidden", source.classList.contains("hidden"));
    clearTimeout(pending);
    if (source.style.visibility === "hidden") return;
    if (source.querySelector(".main-product-price")) {
      pending = setTimeout(() => {
        if (source.style.visibility !== "hidden") copy();
      }, 1500);
      return;
    }
    copy();
  };
  new MutationObserver(sync).observe(source, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ["style", "class"],
  });
  // Liaison faite une frame après l'insertion : BSS a pu déjà réécrire le brouillon.
  sync();
  // Filet : prix toujours masqué 3 s après l'insertion (BSS absent ou sans réécriture).
  setTimeout(() => {
    if (display.style.visibility === "hidden") copy();
  }, 3000);
}

function premiomBindPriceDisplays() {
  document.querySelectorAll("[data-premiom-price-source]").forEach(premiomBindPriceDisplay);
}

// Regroupées par frame : chaque re-render Alpine déclenche de nombreuses mutations.
let premiomBindFrame = 0;
new MutationObserver(() => {
  if (premiomBindFrame) return;
  premiomBindFrame = requestAnimationFrame(() => {
    premiomBindFrame = 0;
    premiomBindBssCheckout();
    premiomBindPriceDisplays();
  });
}).observe(document.body, { childList: true, subtree: true });
premiomBindPriceDisplays();
window.addEventListener("bss_b2b:loadedObserver", premiomBindBssCheckout);
document.addEventListener("eurus:cart:items-changed", premiomBindBssCheckout);
/* Premiom : prix B2B du contenu injecté après le chargement de la page (sélecteur
   d'options des cartes, quick view). Ce HTML vient de la Section Rendering API avec le
   prix public. BSS ne calcule le prix d'une variante précise que dans un formulaire
   produit qu'il a enregistré ([bss-b2b-quickview-product-form], variante lue dans le
   champ `id`) ; son flux « collection » écrit au contraire le prix de la variante la
   moins chère dans tout [bss-b2b-product-price] du produit, quelle que soit la variante
   choisie, et se relance à chaque défilement.
   - `premiom:b2b-form-loaded` (quick-view.js) : enregistre les formulaires injectés et
     calcule leur prix, par le même chemin que la quick view native de BSS ;
   - `premiom:b2b-variant-price` (variant-select.js) : le thème vient de réécrire le prix
     public d'une variante ; BSS recalcule celui du formulaire. Relancé après l'écriture du
     thème, sinon celle-ci peut arriver après BSS et laisser le prix public.
   Le prix est masqué jusqu'à ce que BSS le réaffiche (il le fait aussi sans tarif B2B),
   pour éviter le passage prix public → prix B2B ; filet de sécurité au bout de 2 s. */
const PREMIOM_B2B_FORM_ID = "bss-b2b-product-form-id";

function premiomHideUntilB2B(elements) {
  elements.forEach((el) => {
    el.style.visibility = "hidden";
    clearTimeout(el.premiomB2BRevealTimer);
    el.premiomB2BRevealTimer = setTimeout(() => {
      if (el.style.visibility === "hidden") el.style.visibility = "";
    }, 2000);
  });
}

document.addEventListener("premiom:b2b-form-loaded", async () => {
  if (typeof BSS_B2B === "undefined" || !BSS_B2B) return;
  const forms = document.querySelectorAll(
    `[bss-b2b-quickview-product-form]:not([${PREMIOM_B2B_FORM_ID}])`
  );
  if (!forms.length) return;
  const productIds = [];
  forms.forEach((form) => {
    premiomHideUntilB2B(form.querySelectorAll("[bss-b2b-product-price]"));
    const id = Number(
      form.querySelector("[bss-b2b-product-id]")?.getAttribute("bss-b2b-product-id")
    );
    if (id) productIds.push(id);
  });
  // BSS n'enregistre un formulaire que si son produit est déjà en mémoire.
  await BSS_B2B.storage.productStorage.load(productIds);
  BSS_B2B.observer.productSubject.notifyObserver("ProductMutate", "QuickviewLoaded", {});
});

document.addEventListener("premiom:b2b-variant-price", (event) => {
  if (typeof BSS_B2B === "undefined" || !BSS_B2B) return;
  const productForm = event.detail?.element?.closest(`[${PREMIOM_B2B_FORM_ID}]`);
  if (!productForm) return;
  premiomHideUntilB2B(productForm.querySelectorAll("[bss-b2b-product-price]"));
  BSS_B2B.observer.productSubject.notifyObserver("VariantChange", "VariantSelectChange", {
    productForm,
  });
});

// Premiom : le message « Connectez-vous pour voir vos tarifs » saisi dans l'admin BSS porte
// target="_blank". La connexion s'ouvrait dans un nouvel onglet, et le client perdait la
// fiche qu'il regardait. Écouteur délégué : les messages sont réinjectés par BSS au fil
// des rendus (cartes, vue rapide), un attribut retiré une fois ne suffirait pas.
document.addEventListener("click", (event) => {
  const link = event.target.closest?.('.bsscommerce-ltsp-message a[target="_blank"]');
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
  event.preventDefault();
  window.location.assign(link.href);
});
